import script from "./BeritaTerbaruSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BeritaTerbaruSection.vue?vue&type=script&setup=true&lang=js"

import "./BeritaTerbaruSection.vue?vue&type=style&index=0&id=90c39da6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90c39da6"]])

export default __exports__